// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".christmas-offer-home__safe-area[data-v-249691c2] {\n  position: absolute;\n}\n.christmas-offer-home__content[data-v-249691c2] {\n  margin-top: 0.8rem;\n}\n.christmas-offer-home__img[data-v-249691c2] {\n  max-width: 435px;\n  width: 100%;\n  margin: auto;\n  display: block;\n}\n.christmas-offer-home__btn[data-v-249691c2] {\n  width: 100%;\n  font-weight: 600;\n  background: linear-gradient(90.05deg, #52a376 0.03%, #50a373 98.26%);\n  border-radius: 100px;\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
